import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { AddOrganizationPageComponent } from "./add-organization-page.component";
import { RouterModule } from "@angular/router";

const materialModules = [MatSelectModule];

@NgModule({
  declarations: [AddOrganizationPageComponent],
  imports: [CommonModule, TranslateModule, RouterModule, FormsModule, ReactiveFormsModule, LucideAngularModule, ...materialModules],
})
export class AddOrganizationPageModule {}
